import { type CarItemsActionsType, INIT_CAR_ITEMS } from "../actions/CarItemActions";
import type { ItemsType } from "../../../../../common-deprecated/redux/typeHelpers";

export const initialState: ItemsType = {
    initialized: false,
    colours: [],
    wheels: [],
    upholsteries: [],
    packs: [],
    financePacks: [],
    extras: [],
    equipmentUpholsteries: [],
    wheelExtras: [],
    promotions: [],
    disclaimerPromotions: [],
    filterCarOptions: [],
    winterWheels: [],
    serviceProducts: [],
    tyres: [],
};

const carItemsReducer = (state: ItemsType = initialState, action: CarItemsActionsType): ItemsType => {
    switch (action.type) {
        case INIT_CAR_ITEMS:
            return { ...state, ...action.items, initialized: true };

        default:
            return state;
    }
};

export default carItemsReducer;
